import { Box } from "@mui/material";
import DrawDetailHeroComponent from "./component/DrawDetailHeroComponent";
// import PoolPrizeComponent from "./component/PoolPrizeComponent";
import TopWinnersComponents from "./component/TopWinnersComponents";
import { getFontColorFromBackground } from "../../../utils/common";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import DrawTicket from "./component/DrawTicket";
import JoinCompetition from "./component/JoinCompetition";
import DrawDetailsReferral from "./component/DrawDetailsReferral";
import { fetchDrawDetailsApi } from "../../../api/ApiService";
import { blockchainNetworks } from "../../../config/blockchain";

const DrawDetailPages = () => {
  const location = useLocation();
  const drawId = location.pathname.split("/")[2];
  const [drawDetailData, setDrawDetailData] = useState({});
  const [loading, setLoading] = useState(false);
  const [isImageDark, setIsImageDark] = useState(false);

  const getDrawDetailApi = async (drawId) => {
    try {
      setLoading(true);
      const response = await fetchDrawDetailsApi(drawId);
      if (response && response.data) {
        const drawData = response.data;
        const blockchainNwt = blockchainNetworks[drawData?.blockchain];
        const drawDetails = {
          ...drawData,
          ...blockchainNwt,
        };
        setDrawDetailData(drawDetails);
        const isDarkImage = await getFontColorFromBackground(
          drawDetails?.bannerImage
        );
        setIsImageDark(isDarkImage);

      }
      console.log("Draw Details: ", drawDetailData);
      setLoading(false);
    } catch (error) {
      console.log("Error fetching draw details:", error);
    }
  };

  useEffect(() => {
    if (drawId) {
      getDrawDetailApi(drawId);
    }
  }, [drawId]);

  return (
    <Box>
      <DrawDetailHeroComponent drawData={drawDetailData} isImageDark={isImageDark} />
      <DrawTicket drawData={drawDetailData} />
      {/* <PoolPrizeComponent
        poolPrize={drawDetailData?.rewardPoolPrize}
        tickerUnit={drawDetailData?.currencyTicker}
      /> */}
      <TopWinnersComponents drawDetailData={drawDetailData}
        tickerUnit={drawDetailData?.currencyTicker}
      />
      {/* <DrawPercentage
        winProbability={drawDetailData?.winningProbability}
        totalPlayers={drawDetailData?.totalWinners}
        tickerUnit={drawDetailData?.currencyTicker}
      /> */}
      <JoinCompetition />
      <DrawDetailsReferral
        dataLoading={loading}
        referralDetails={drawDetailData?.referralDetails}
        tickerUnit={drawDetailData?.currencyTicker}
      />

    </Box>
  );
};
export default DrawDetailPages;
